import { defineCopy } from "@tami/core/intl";

import { FINANCE_SCRIPT_COPY_EN_US } from "./en-us/finance-script.copy";
import { FINANCE_SCRIPT_COPY_ES_ES } from "./es-es/finance-script.copy";

export const FINANCE_SCRIPT_COPY_PT_BR = {
  finIntro: {
    narrative:
      "Finanças do creator: entenda quanto entrou, quanto saiu e o que ainda falta receber — sem planilha manual.",
  },
  finMain: {
    narrative:
      "Receitas de campanhas entram automaticamente no financeiro. Veja tudo que entrou e saiu no mês.",
    callout:
      "Tudo que entrou, o que sobrou no bolso e a margem — visíveis num relance.",
  },
  finOverview1: {
    narrative:
      "Organize datas de pagamento e recebimento sem perder nenhuma fatura.",
  },
  finInvoicesOpen: {
    narrative:
      "Fique de olho: abra a gestão e veja cada entrada e saída do mês numa tabela clara.",
    callout:
      "Gestão da sua grana — busque, exporte e acompanhe todas as faturas.",
  },
  finInvoicesTable: {
    narrative:
      "Campanhas, despesas e receitas avulsas — tudo com tipo, vencimento e status pendente ou pago.",
    callout:
      "Cada linha mostra de onde veio, quanto foi e se já caiu na conta.",
  },
  finInvoicesStatus: {
    narrative:
      "Marque como pago ou edite quando precisar — controle total sobre o que ainda está pendente.",
    callout:
      "Status e parcelas visíveis — nada passa batido no fechamento do mês.",
  },
  finNewInvoiceOpen: {
    narrative:
      "Registre uma receita ou despesa nova em segundos — sem sair do painel financeiro.",
    callout:
      "Nova receita ou despesa — fluxo rápido para lançar qualquer movimentação.",
  },
  finNewInvoiceDesc: {
    narrative:
      "Descreva o lançamento: honorário, equipamento, café ou qualquer movimentação do dia.",
    callout:
      "Nomeie a entrada — fica fácil achar depois na gestão de faturas.",
  },
  finNewInvoiceMeta: {
    narrative:
      "Recebeu ou gastou? Única ou parcelada? Data e tipo definem como entra no relatório.",
    callout:
      "Tipo, frequência e data — a Tãmi organiza entradas e saídas automaticamente.",
  },
  finNewInvoiceAmount: {
    narrative:
      "Informe o valor e salve — o lançamento entra na gestão e nos gráficos do mês.",
    callout:
      "Quanto entrou ou saiu — um clique e pronto, sem planilha.",
  },
  finDetailed: {
    narrative:
      "Despesas, ticket médio e ROI de campanha — números que te ajudam a cobrar e negociar melhor.",
    callout:
      "Descubra seu ticket médio, ROI e o que ainda está pendente de pagamento.",
  },
  finOverview2: {
    narrative:
      "Conferir a fatura do mês e dar check em cada movimentação fica simples.",
  },
  finChartPlatform: {
    narrative:
      "Instagram, TikTok ou YouTube — descubra qual rede concentrou mais receita no período.",
    callout:
      "Receita por plataforma: veja onde sua audiência mais converte em dinheiro.",
  },
  finChartType: {
    narrative:
      "Reels, stories ou vídeo longo — compare formatos e invista no que mais retorna.",
    callout:
      "Tipo de conteúdo vs. faturamento — dados para priorizar o que produzir.",
  },
  finChartBrands: {
    narrative:
      "Saiba quais marcas mais investiram em você — útil para renovar parcerias e precificar.",
    callout:
      "Ranking de marcas por receita — histórico claro para negociar a próxima campanha.",
  },
} as const;

export const FINANCE_SCRIPT_COPY = defineCopy(FINANCE_SCRIPT_COPY_PT_BR, {
  "en-US": FINANCE_SCRIPT_COPY_EN_US,
  "es-ES": FINANCE_SCRIPT_COPY_ES_ES,
});
